/**
 * KnewtonChatButton - Floating chat button for premium users
 * Opens the Knewton chat drawer for AI-powered player discovery
 */

import { useState } from 'react';
import { ChatBubbleLeftRightIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../../contexts/AuthContext';
import KnewtonChatDrawer from './KnewtonChatDrawer';

export default function KnewtonChatButton() {
  const { userProfile } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Only show for premium subscribers
  const isPremium = userProfile?.subscription_tier === 'premium' ||
                    userProfile?.subscription_tier === 'pro' ||
                    userProfile?.is_admin;

  if (!isPremium) return null;

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          fixed bottom-6 right-6 z-40
          w-14 h-14 rounded-full
          flex items-center justify-center
          shadow-lg shadow-purple-500/30
          transition-all duration-300 transform
          ${isOpen
            ? 'bg-gray-700 hover:bg-gray-600 rotate-0'
            : 'bg-gradient-to-br from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 hover:scale-110'
          }
        `}
        title="Ask Knewton"
      >
        {isOpen ? (
          <XMarkIcon className="w-6 h-6 text-white" />
        ) : (
          <div className="relative">
            <ChatBubbleLeftRightIcon className="w-6 h-6 text-white" />
            {/* Pulse indicator */}
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-pulse" />
          </div>
        )}
      </button>

      {/* Knewton branding tooltip on hover */}
      {!isOpen && (
        <div className="fixed bottom-6 right-22 z-40 pointer-events-none">
          <div className="bg-gray-900 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Ask Knewton
          </div>
        </div>
      )}

      {/* Chat Drawer */}
      <KnewtonChatDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
